import { useState, useCallback } from "react";
import PropTypes from "prop-types";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "../form/Button";
import DataLayerViewer from "./DataLayerViewer";

/**
 * Composant Button qui ouvre/ferme automatiquement le DataLayerViewer
 */
const DataLayerViewerButton = ({
	variant = BUTTON_VARIANTS.FILLED,
	size = BUTTON_SIZES.SMALL,
	children = "Voir dataLayer en temps réel",
	...buttonProps
}) => {
	const [isViewerVisible, setIsViewerVisible] = useState(false);

	const handleViewerClose = useCallback(() => {
		setIsViewerVisible(false);
	}, []);

	// Utilisation du composant DataLayerViewer qui retourne des méthodes
	const { closeViewer, isViewerOpen } = DataLayerViewer({
		isVisible: isViewerVisible,
		onClose: handleViewerClose,
	});

	const handleButtonClick = useCallback(() => {
		if (isViewerOpen) {
			// Si la popup est ouverte, on la ferme
			closeViewer();
		} else {
			// Si la popup est fermée, on l'ouvre
			setIsViewerVisible(true);
		}
	}, [isViewerOpen, closeViewer]);

	return (
		<Button variant={variant} size={size} onClick={handleButtonClick} {...buttonProps}>
			{children} {isViewerOpen ? "🔗" : ""}
		</Button>
	);
};

DataLayerViewerButton.propTypes = {
	variant: PropTypes.string,
	size: PropTypes.string,
	children: PropTypes.node,
};

export default DataLayerViewerButton;
